import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Prismic from 'prismic-javascript';

import LanguageContext from '../../context/LangContext';

import Unit from './unit'

const Container = styled.div`
  margin-top: 60px;
  display: inline-block;
  width: 100%;
  strong {
    font: bold italic 28px 'Times new roman';
    margin-bottom: 24px;
    display: block;
  }
  .holder {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
`

const Buttons = styled.div`
  display: flex;
  align-content: space-between;
  width: 82px;
  height: 270px;
  flex-wrap: wrap;
  button {
    background: #fff;
    border-radius: 3px;
    border: 0;
    cursor: pointer;
    height: calc(50% - 10px);
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    &.right {
      background-image: url(/images/arrow-right-bold.png);
    }
    &.left {
      background-image: url(/images/arrow-left-bold.png);
    }
  }
`

const Items = styled.div`
  width: 100%;
  height: 270px;
  overflow: hidden;
  display: flex;
  .slider {
    transition: all 0.3s;
    display: flex;
    width: 100%;
  }
`

const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
const Client = Prismic.client(apiEndpoint);

class Combinations extends Component {
  state = {
    items: [],
    categoria: [],
    slide: 0,
    slide_total: 0,
    pace: 0,
  }

  componentDidMount = () => {
    const { language } = this.context;
    const fetchDataCategoria = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'categoria_produtos'),
        { lang: language }
      )
      if (response) {
        this.setState({categoria: response.results});
        this.getItems();
      }
    }
    fetchDataCategoria();

    window.addEventListener("resize", this.resize.bind(this));
    this.resize()
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  resize = () => {
    if (document.body.clientWidth < 540) {
      this.setState({ pace: 100, slide_total: this.props.combinacoes.length - 1 });
    } else if(document.body.clientWidth > 789 && document.body.clientWidth < 980) {
      this.setState({ pace: 50, slide_total: this.props.combinacoes.length - 1 });
    } else {
      this.setState({ pace: 25, slide_total: this.props.combinacoes.length - 4 });
    }
  }

  getItems = () => {
    const { combinacoes } = this.props;
    const ids = []
    combinacoes.map((item) => {
      if (item.produto.id)
        ids.push(item.produto.id)
      return false;
    })

    const fetchDataProdutos = async () => {
      const response = await Client.query(
        Prismic.Predicates.in('document.id', ids)
      )
      if (response) {
        response.results.map((item) => {
          item.category = this.state.categoria.filter((categoria) => categoria.id === item.data.categoria_produto.id)[0]
          return true;
        })
        this.setState({items: response.results});
      }
    }
    fetchDataProdutos();
  }

  slideLeft = () => {
    if (this.state.slide > 0) {
      this.setState({ slide: this.state.slide - 1});
    }
  }

  slideRight = () => {
    if (this.state.slide < this.state.slide_total) {
      this.setState({ slide: this.state.slide + 1});
    }
  }

  render = () => {
    const { language } = this.context;
    let title = ''
    switch (language) {
      case 'pt-br':
        title = 'Combinações sugeridas';
        break;
      case 'en-us':
        title = 'Suggested combinations';
        break;
      case 'es-es':
        title = 'Combinaciones sugeridas';
        break;
      default:
    }
    return this.state.items.length > 0 ? (
      <Container>
        <strong>{ title }</strong>
        <div className="holder">
          <Items>
            <div className="slider" style={ { transform: `translateX(-${this.state.slide * this.state.pace}%)`}}>
              { 
                this.state.items.map((item, index) => {
                  return (
                    <Unit {...item.data} uid={ item.uid } category={ item.category && item.category.data } key={ index } />
                  )
                })
              }
            </div>
          </Items>
          <Buttons>
            <button className="right" onClick={ this.slideRight }></button>
            <button className="left" onClick={ this.slideLeft }></button>
          </Buttons>
        </div>

      </Container>
    ) : (<></>)
  }
}

Combinations.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Combinations.contextType = LanguageContext;

export default Combinations;
